export default __webpack_public_path__ + "static/media/ico-stand.45e72d8c.svg";